/* globals jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'magnific-popup'
import objectFitImages from 'object-fit-images';

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //polyfill for IE object-fit on images - https://github.com/fregante/object-fit-images
    var $objectFit = $('img.object-fit');
    objectFitImages($objectFit);

    //OPEN SEARCH MODAL
    $('.open-search').magnificPopup({
        type:'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        removalDelay: 300,
        mainClass: 'mfp-fade',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
    });

    // close button on search popup
    $(document).on('click', '.close-btn', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // esc key search popup close.
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            e.preventDefault();
            $.magnificPopup.close();
        }
    });

    //main hero slideshow
    $('.slideshow.flexslider').flexslider({
        controlNav: false,
    });

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent, .pattern--video-row').fitVids();

    // Accordions
    $('dl.js-accordion').accordion();

    //Provider filters accordion
    $('.js-toggle-filter').on('click', function(e){
        e.preventDefault();

        var $panel = $(this).closest('.filters');
        $panel.toggleClass('active');
        $panel.next('dd').slideToggle();
    });


})(jQuery)
